export default [{
  path: 'recoverySettlementsList',
  name: 'recoverySettlementsList',
  component: function component() {
    return import('@/views/recoveryManage/recoverySettlements/index');
  }
}];